export interface AeratorType {
  id: number;
  name: string;
}

/**
 * Hardcoded values as this is not an endpoint we need to request almost ever.
 */
export const AeratorTypes: AeratorType[] = [
  {
    id: 0,
    name: 'electric',
  },
  { id: 1, name: 'diesel' },
];
